module.exports = __webpack_public_path__ + "img/fn_02.95ad71a5.jpg";